import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../store";

interface ThemeState {
  mode: "lightTheme" | "darkTheme" | null | undefined;
  themeState: any;
}

const storedTheme = localStorage.getItem("theme");

const initialState: ThemeState = {
  mode: (storedTheme as "lightTheme" | "darkTheme") || "darkTheme",
  themeState: null,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggle: (state) => {
      const themeLocal = localStorage.getItem("theme");
      const newTheme = themeLocal === "lightTheme" ? "darkTheme" : "lightTheme";
      localStorage.setItem("theme", newTheme);
      state.mode = newTheme;
    },
    updateThemeState: (state, payload) => {
      state.themeState = payload
    }
  },
});

export const { toggle, updateThemeState } = themeSlice.actions;

export const selectTheme = (state: RootState) => state.theme.mode;

export default themeSlice.reducer;
